import React from "react";

const GallerySection = () => {
  const galleryItems = [
    { title: "", image: "/images/gallery/2.jpeg" },
        { title: "", image: "/images/gallery/7.jpeg" },
    { title: "", image: "/images/gallery/6.jpeg" },



    { title: "Honda Amaze", image: "/images/fleet/amaze.jpg" },
    { title: "Audi A4", image: "/images/fleet/audi.jpg" },
    { title: "Hyundai Aura", image: "/images/fleet/aura.jpg" },
    // { title: "Luxury Bus", image: "/images/fleet/bus.jpg" },
    { title: "Maruti Suzuki Ertiga", image: "/images/fleet/ertiga.jpg" },
    { title: "Toyota Etios", image: "/images/fleet/etios.jpg" },
    { title: "Honda City", image: "/images/fleet/honda-city.jpg" },
    // { title: "Toyota Innova", image: "/images/fleet/innova.jpg" },
    { title: "Innova Crysta", image: "/images/fleet/innova-crysta.jpg" },
    { title: "Kia Carens", image: "/images/fleet/kia.jpg" },
    { title: "Mini Bus", image: "/images/fleet/mini-bus.jpg" },
    { title: "Tempo Traveller", image: "/images/fleet/tempo-traveller.jpg" },
        { title: "", image: "/images/gallery/1.jpeg" },
    { title: "", image: "/images/gallery/3.jpeg" },
    { title: "", image: "/images/gallery/5.jpeg" },
    { title: "", image: "/images/gallery/9.jpeg" },
    { title: "", image: "/images/gallery/8.jpeg" },

  ];

  return (
    <>
      {/* Breadcrumb */}
      <section className="gauto-breadcromb-area section_70">
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <div className="breadcromb-box">
                <h3>Gallery</h3>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Gallery Start */}
      <section className="gauto-gallery-area section_70">
        <div className="container">
          <div className="row" id="lightgallery">

            {galleryItems.map((item, index) => (
              <div key={index} className="col-lg-4 col-md-6 mb-4" data-src={item.image}>
                <div className="single-gallery bordered-card">
                  
                  <div className="img-holder">
                    <img className="gallery-img" src={item.image} alt={item.title} />

                    <div className="overlay-content">
                      <div className="inner-content">
                        <div className="title-box">
                          <h3><a href="#">{item.title}</a></h3>
                        </div>
                      </div>
                    </div>

                    <div className="link-zoom-button">
                      <div className="single-button">
                        <a href="#"><span className="fa fa-link"></span> Details</a>
                      </div>
                      <div className="single-button">
                        <a className="zoom lightbox-image" href={item.image}>
                          <span className="fa fa-search"></span> Zoom
                        </a>
                      </div>
                    </div>
                  </div>

                </div>
              </div>
            ))}

          </div>
        </div>
      </section>
      {/* Gallery End */}
    </>
  );
};

export default GallerySection;
